// components/NetworkErrorBackdrop.jsx
import { useState, useEffect, useRef } from 'react';
import { Backdrop, Box, Typography, Button, Paper } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';

export default function NetworkErrorBackdrop() {
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const handleNetworkError = () => {
      setOpen(true);

      // Auto-close after 8 seconds
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setOpen(false);
      }, 8000);
    };

    window.addEventListener('global-network-error', handleNetworkError);

    return () => {
      window.removeEventListener('global-network-error', handleNetworkError);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 9999, // Ensure it's on top of everything
        backdropFilter: 'blur(3px)'
      }}
      open={open}
    >
      <Paper
        elevation={24}
        sx={{
          p: 4,
          maxWidth: 400,
          textAlign: 'center',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: 'error.light',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 1
          }}
        >
          <WifiOffIcon sx={{ fontSize: 32, color: 'error.main' }} />
        </Box>

        <Typography variant="h5" component="h2" fontWeight="bold">
          Connection Interrupted
        </Typography>

        <Typography variant="body1" color="text.secondary">
          The server is taking too long to respond or your internet connection is unstable. Please check your network and try again later.
        </Typography>

        <Button variant="contained" color="primary" onClick={handleClose} sx={{ mt: 2, px: 4, py: 1, borderRadius: 8 }}>
          Oke
        </Button>
      </Paper>
    </Backdrop>
  );
}
